import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import './style.scss';

const Layout = ({ children }) => (
  <div className='layout'>
    <Header />
      {children}
    <Footer />
  </div>
)

export default Layout;